export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/admin": [4],
		"/before-you-buy": [5],
		"/cancel": [6],
		"/confirmation-page": [7],
		"/diagnostic-welcome": [8],
		"/final-sales-funnel": [9],
		"/get-my-custom-study-plan": [10],
		"/get-my-custom-study-plan/generating": [11],
		"/get-my-custom-study-plan/survey-questions": [12],
		"/new/learn/[slug]": [13],
		"/new/learn/[slug]/open": [14],
		"/new/learn/[slug]/overview": [15],
		"/next-steps": [16],
		"/payment-success": [17],
		"/pricing": [18],
		"/reports": [19],
		"/user-info": [20],
		"/[...catchall]": [3]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';